import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { RemoveCommaPipe } from '@shared/pipes/remove-comma/remove-comma.pipe';
import { SharedModule } from '@shared/shared.module';
import { GET_UPSELL_PRODUCT_LOV, STORE_UPSELL_PRODUCT } from '@store/sat-motor/sat-motor.action';

@Component({
  selector: 'app-upsell-product',
  standalone: true,
  imports: [
    SharedModule,
  ],
  providers: [DecimalPipe],
  templateUrl: './upsell-product.component.html',
  styleUrl: './upsell-product.component.scss'
})
export class UpsellProductComponent implements OnInit {
  @Input() parentForm: FormGroup;
  upsellProductForm: FormGroup;
  upsellProductList: any;
  upsellProductFromState: any;
  userInfo: any;
  isUpdatePayment: any;
  opportunityId: any;
  numberFmt: any;

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private decimalPipe: DecimalPipe,
  ) {
    this.numberFmt = new RemoveCommaPipe();
  }

  ngOnInit(){
    this.userInfo = this.store.selectSnapshot<any>(state => state.UserState.user);
    let productCode = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step1.issuance.issuance.productCode);
    let agentCode = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step1.agentDetail.agentCode);
    this.isUpdatePayment = this.store.selectSnapshot<any>(state => state.SatMotorState.isUpdatePayment);
    this.opportunityId = this.store.selectSnapshot<any>((state) => state.SatMotorState.opportunityId);
    this.store.dispatch(new GET_UPSELL_PRODUCT_LOV({
      listTypes: this.opportunityId ? ["upsellProductListOcc"] : ["upsellProductList"],
      agentCode: agentCode,
      productType: "MT",
      productCode: productCode,
    })).subscribe(state => {
      this.upsellProductList = this.opportunityId ? state.SatMotorState.upsellProductLov.upsellProductListOcc : state.SatMotorState.upsellProductLov.upsellProductList;
    });

    this.upsellProductFromState = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step4.upsellProduct);

    this.upsellProductForm = this.fb.group({
      upSellType: [this.upsellProductFromState?.upSellType ? this.upsellProductFromState.upSellType : ''],
      upSellAmt: [this.upsellProductFromState?.upSellAmt ? this.upsellProductFromState.upSellAmt : ''] 
    });

    // if(this.userInfo.issueOnQuotation) {
    //   this.upsellProductForm.disable();
    // }

    if(this.isUpdatePayment) {
      this.upsellProductForm.disable();
    }

    this.parentForm.addControl("upsellProductForm", this.upsellProductForm);

    this.onChangeUpsellProduct();
  }

  onChangeUpsellProduct() {
    let upsellProductControl = this.upsellProductForm.controls['upSellType'];
    let upsellProductAmountControl = this.upsellProductForm.controls['upSellAmt'];
    let upsellProductValue = upsellProductControl.value;
    
    if(upsellProductValue) {
      upsellProductAmountControl.enable();
      upsellProductAmountControl.setValidators(Validators.required);
      upsellProductAmountControl.updateValueAndValidity();
      this.storeUpsellProduct();
    }else {
      upsellProductAmountControl.removeValidators(Validators.required);
      upsellProductAmountControl.updateValueAndValidity();
      upsellProductAmountControl.reset();
      upsellProductAmountControl.disable();
      this.storeUpsellProduct();

    }
  }

  onChangeUpsellProductAmount() {
    let upsellProductAmount = this.upsellProductForm.controls['upSellAmt'].value;
    
    this.storeUpsellProduct();
  }

  storeUpsellProduct() {
    let upsellProductValue = this.upsellProductForm.controls['upSellType'].value;
    let upsellProductAmount = this.removeNumberSpecialCharacter(this.upsellProductForm.controls['upSellAmt'].value);

    let payload = {
      upSellType: upsellProductValue,
      upSellAmt: upsellProductAmount
    }
    this.store.dispatch(new STORE_UPSELL_PRODUCT(payload));
  }

  onBlurUpsellProductAmount(ev) {
    this.upsellProductForm.controls['upSellAmt'].setValue(this.currencyFormat(ev));
  }

  currencyFormat(ev) {
    let currency = this.formatToNumber(ev.target.value);

    if (typeof currency === 'number') {
      currency = this.decimalPipe.transform(currency, '1.2-2');
    }
    return currency;
  }

  formatToNumber(value) {
    if (typeof value === 'string') {
      let number = value;
      number = number.replace(',', '');

      return Number(number);
    }
    else return value;
  }

  removeNumberSpecialCharacter(value) {
    let removedCommaValue = this.numberFmt.transform(value);

    return Number(removedCommaValue);
  }
}
